let forms = {
   queryID: {
      icon: 'fa fa-pound-sign',
      title: 'Query By Transaction Ref',
      subtitle: 'Query transactions by Transaction Ref',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-9', model: 'tranRef',
            validation: 'required|min:3|max:16', label: 'External Ref Number',
         },
      ]
   },
   queryByRange: {
      icon: 'fa fa-pound-sign',
      title: 'Query By Date',
      subtitle: 'Query transactions by Date',
      forms: [
         // {
         //    type: 'select', class: 'col-12 col-md-5', model: 'status', filterable: true, clearable: true,
         //    multiple: false, max_tag_count: 1, options: [
         //       { val: 'PROCESSING', label: 'Pending' },
         //       { val: 'SUCCESS', label: 'Complete' },
         //       { val: 'FAILED', label: 'Failed' },
         //    ], validation: '', label: 'Status'
         // },
         {
            type: 'datepicker', form_type: 'daterange', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'duration', label: 'Query Date', class: 'col-12', validation: 'required'
         },
      ]
   },
}

let tables = {
   transactions: {
      icon: 'fa fa-pound-sign',
      title: 'Transactions',
      table_fields: [
         { name: 'Internal Ref', align: 'l' },
         { name: 'Transaction Ref', align: 'l' },
         { name: 'Amount', align: 'l' },
         { name: 'Verification Date', align: 'c' },
         { name: 'Verification Time', align: 'c' },
         { name: 'Transaction Status', align: 'l' },
         // { name: 'Actions', align: 'c' }
      ],
      search_fields: ["_id", "transaction_id", "amount"],
      row_data: [
         { type: 'text', field: '_id', class: 'bold' },
         { type: 'text', field: 'transaction_id', class: 'bold' },
         { type: 'text', field: 'amount', class: 'bold bigger' },
         { type: 'date', field: 'verified_at', class: 'center bolder', format: 'DD-MM-YYYY' },
         { type: 'date', field: 'verified_at', class: 'center bolder', format: 'HH:mm' },
         { type: 'text', field: 'status', class: 'bold' },
         // {
         //    type: 'action', field: 'name', class: 'center', icon: '', actions: [
         //       // {type: 'title', title: 'Actions'},
         //       { type: 'menu', title: 'View', event: 'product:view' },
         //       { type: 'menu', title: 'Edit', event: 'product:edit', icon: 'fa-edit' },
         //       { type: 'menu', title: 'Delete', event: 'product:delete', icon: 'fa-trash-alt' },
         //    ]
         // },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}